import React from "react";
//home page can be changed for any page
import CenterPanelAppointment from "./centerPanel";
import ReusableBottomPanelAppointment from "./components/reusableBottomPanel";

export default function AppointmentContent() {
  return (
    <div className="appointment-step">
      <CenterPanelAppointment />
      <ReusableBottomPanelAppointment validationDataGroup="firstStepAppointment" />
    </div>
  );
}
